exports["UK"] = require("./UK.js");
exports["DE"] = require("./DE.js");